var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"title":_vm.model}},[_c('v-autocomplete',{attrs:{"hint":_vm.hint,"persistent-hint":"","items":_vm.selectItems,"disabled":_vm.disabled,"rules":_vm.computedRules,"label":_vm.label,"item-text":_vm.itemText,"item-value":_vm.itemValue,"clearable":""},on:{"input":function($event){return _vm.update()}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n\t\t\t"+_vm._s(!data.item
					? ''
					: !_vm.itemText
					? data.item
					: typeof _vm.itemText === 'function'
					? _vm.itemText(data.item)
					: data.item[_vm.itemText])+"\n\t\t")]}},{key:"item",fn:function(data){return [_vm._v("\n\t\t\t"+_vm._s(!data.item
					? ''
					: !_vm.itemText
					? data.item
					: typeof _vm.itemText === 'function'
					? _vm.itemText(data.item)
					: data.item[_vm.itemText])+"\n\t\t")]}}]),model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a18a7ae","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/baseComponents/inputs/selectInput.vue
// module id = null
// module chunks = 